/* eslint-disable @reatom/unit-naming-rule */
import { PoolEvent } from '@blade/blockchain-types'
import { Result } from '@blade/std-lib'
import { pairRegistry } from '@root/entities/pair/atoms'
import { fetchTrendingPairsRequestAction } from '@root/features/trending-pairs/atoms/trending-requests'
import {
  DEFAULT_TRENDING_STRATEGY,
  trendingIsLiveAtom,
  trendingPollAtom,
  trendingStrategyAtom,
} from '@root/features/trending-pairs/atoms/trending-strategy'

import { ExploreFilter } from '../model'
import { EXPLORE_LIST_PERIOD_MAP } from '../model/constants'
import { ExploreFeedType } from '../model/explore-feed-type'

import { reatomPairEventsCommon } from './reatom-explore-events'
import { trendingExploreFiltersAtom } from './reatom-explore-filters'

export const reatomExploreTrendingPairs = () => {
  const pairsStateAtom = reatomPairEventsCommon({
    event: PoolEvent.Trending,
    // compare: reatomPair.cmpTrending,
    filter: trendingExploreFiltersAtom,
    period: EXPLORE_LIST_PERIOD_MAP[ExploreFeedType.Trending],
    // The socket pushes one trending list — ours. While the column is showing
    // another ranking its pushes are dropped, or they would replace that list
    // a second after it was drawn.
    live: trendingIsLiveAtom,
    loadItems: async (ctx, { limit, network, filter, period }) => {
      // Spied before anything is awaited, so switching the ranking, or the
      // beat that keeps a list the socket does not push from going stale,
      // makes this run again.
      const strategy = ctx.spy(trendingStrategyAtom)
      ctx.spy(trendingPollAtom)

      const filters = filter
        ? ExploreFilter.toPoolFiltersDto(filter, undefined, period)
        : undefined
      const result = await ctx.schedule(() =>
        fetchTrendingPairsRequestAction(ctx, {
          filters,
          offset: 0,
          limit,
          network,
          ...(strategy === DEFAULT_TRENDING_STRATEGY ? {} : { strategy }),
        }),
      )

      return result.pipe(
        Result.map((it) =>
          it.data.map((dto) => pairRegistry.resolveFromDto(ctx, dto)),
        ),
      )
    },
  })

  return pairsStateAtom
}
export type ExploreTrendingPairsModel = ReturnType<
  typeof reatomExploreTrendingPairs
>

export const exploreTrendingModel = reatomExploreTrendingPairs()
